/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
		var scroll = new SmoothScroll('a[href*="#"]', {
			speed: 1000, // Integer. How fast to complete the scroll in milliseconds
			offset: 0, // Integer or Function returning an integer. How far to offset the scrolling anchor location in pixels
			easing: 'easeInOutCubic', // Easing pattern to use
		});
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

new WOW().init();

var nav = responsiveNav(".nav-collapse", { // Selector
	animate: true, // Boolean: Use CSS3 transitions, true or false
	transition: 284, // Integer: Speed of the transition, in milliseconds
	customToggle: "#sc-nav-toggle", // Selector: Specify the ID of a custom toggle
});

jQuery(document).ready(function($) {
	$(function(){
		$('.owl-carousel').owlCarousel({
			items: 1,
			loop: true,
			autoplay: true,
			autoplayTimeout: 10000,
			animateIn: 'fadeIn',
			animateOut: 'fadeOut',
			autoHeight: true,
			center: true,
			mouseDrag: false,
			pullDrag: false,
			touchDrag: false
		});
		
	    $(".sc-sidebar-menu").tinyNav({
		    header: 'Please choose a section...',
	    });

	});
});